module.exports = __webpack_public_path__ + "img/portal2.b2cd512d.png";